import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';

export const CloseIconSt = styled.span`
  z-index: 1;
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  margin: 1rem;
  ${media.sm(
    css`
      margin: 0;
    `,
  )}
`;
